// AuthServ.js
import { get, post } from "./base.js";

let profilePromise = null;

const AuthServ = {
  // Get logged user from backend with promise caching (deduplication)
  single: (force = false) => {
    if (force || !profilePromise) {
      profilePromise = get(`/auth/me`).catch(err => {
        profilePromise = null; // Clear cache on error
        throw err;
      });
    }
    return profilePromise;
  },

  clearCache: () => {
    profilePromise = null;
  },

  // Auth APIs
  login: (email, password) => post("/auth/login", { email, password, source: 'web' }),
  register: (payload) => post("/auth/register", payload),
  checkEmailExists: (email) => post("/auth/check-email", { email }),
  checkMobileExists: (mobile) => post("/auth/check-mobile", { mobile }),
  checkUser: (identifier) => post("/auth/check-user", { identifier }),
  registerSeller: (payload) => post("/auth/register-seller", payload),
  sellerRegister: (payload) => post("/auth/register-seller", payload),
  customerRegister: (payload) => post("/auth/register", payload),
  forgotPassword(data) { return post("/auth/forgot-password", data); },
  verifyOtp(data) { return post("/auth/verify-otp", data); },
  resetPassword(data) { return post("/auth/reset-password", data); },
  generateOtpByMobile: (mobile, action = 'signup') => post("/auth/generate-otp-mobile", { mobile, action }),
  verifyOtpByMobile: (mobile, otp) => post("/auth/verify-otp-mobile", { mobile, otp, source: 'web' }),
  // Check token exist
  isLogged: () => {
    let token = localStorage.getItem("token") || localStorage.getItem("customerToken");
    return !!token;
  },

  // Logout
  logout: () => {
    localStorage.clear();
    AuthServ.clearCache();
    window.dispatchEvent(new Event("auth-change"));
  },

  // Get user from localStorage
  getUser: () => {
    let user = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  },

  // Update user in localStorage
  updateUser: (newUserData) => {
    localStorage.setItem("user", JSON.stringify(newUserData));
    return newUserData;
  },
};

export default AuthServ;
